export const graphPercentage = (value, gaugeAngle) => {
  if (!value || value < 0) return [0, gaugeAngle];
  const gauge = (gaugeAngle * value) / 100;
  return gauge > gaugeAngle ? [100, 0] : [gauge, gaugeAngle - gauge];
};
